



















































import Vue from 'vue'
import Component from 'vue-class-component'
import RespondecoPagination from '@/main/respondeco-pagination.vue'
import { OrganisationLite } from '@/business/organisation/interfaces/organisation-lite'
import RespondecoResponsiveImage from '@/shared/components/respondeco-responsive-image.vue'
import { DataSourcePaginator } from '@/shared/models/data/data-source-paginator'
import { Hooks } from '@/shared/interfaces/hooks'
import { OfferResponse, OfferResponsePartner } from '@/api/generated'
import { DataSource } from '@/shared/models/data/data-source'
import { OfferPartnerDataSource } from '@/business/offers/offer-partner-data-source'
import RespondecoLoadingIndicator from '@/shared/components/respondeco-loading-indicator.vue'
import { Prop } from 'vue-property-decorator'

@Component({
  name: 'offer-partners',
  components: { RespondecoLoadingIndicator, RespondecoPagination, RespondecoResponsiveImage },
})
export default class OfferPartners extends Vue implements Hooks {
  @Prop({
    required: true,
    type: Object,
  })
  public readonly offer!: OfferResponse

  @Prop({
    default: false,
    type: Boolean,
  })
  public readonly showOrganisation!: boolean

  private dataSource!: DataSource<OfferResponsePartner>
  private paginator!: DataSourcePaginator<OfferResponsePartner>

  public get loading(): boolean {
    return this.dataSource.isLoading()
  }

  public get page(): number {
    return this.paginator.page
  }

  public get pageSize(): number {
    return this.paginator.pageSize
  }

  public get partners(): OrganisationLite[] {
    let partners = this.paginator.items.map(item => item.organisation)

    if (this.showOrganisation) {
      partners = [this.offer.organisation].concat(partners)
    }

    return partners
  }

  public get total(): number {
    return this.paginator.total
  }

  constructor() {
    super()

    this.dataSource = new OfferPartnerDataSource()
    this.paginator = new DataSourcePaginator<OfferResponsePartner>(this.dataSource).changePageSize(
      8
    )
  }

  public mounted() {
    this.paginator.initialize()
  }

  public updatePage(page: number): void {
    this.paginator.changePage(page).update()
  }
}
